import {Home} from '../components/home';

export function HomeContainer() {

    return (
        <>
            <Home />
        </>
    );
}

